"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var $ = require("jquery");
var utils_1 = require("./utils");
require("./ToolTip.scss");
var ToolTipMethods;
(function (ToolTipMethods) {
    ToolTipMethods["hover"] = "hover";
    ToolTipMethods["click"] = "click";
    ToolTipMethods["manual"] = "manual";
})(ToolTipMethods = exports.ToolTipMethods || (exports.ToolTipMethods = {}));
var cloneChildrenElement = function (ReactElement, options) {
    if (options === void 0) { options = {}; }
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    return Array.prototype.concat.call([], ReactElement).map(function (Element) {
        return React.cloneElement.apply(React, [Element, options].concat(children));
    });
};
var ToolTipGuide = function (props) {
    return (React.createElement("div", { className: 'tooltip-container' },
        React.createElement("div", { className: 'tooltip-title' }, props.title),
        React.createElement("div", { className: 'tooltip-body' }, props.description)));
};
var ToolTip = /** @class */ (function (_super) {
    __extends(ToolTip, _super);
    function ToolTip(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            // shown: _isNull(props.defaultShown) ? false : !!props.defaultShown,
            shown: false,
        };
        _this.guideID = '';
        _this.hidingConfirmed = true;
        _this.hidingDelayTime = 200;
        _this.tipBodyMinHeight = 50;
        _this.triggerTarget = utils_1._isNull(props.defaultTriggerTarget)
            ? null
            : props.defaultTriggerTarget;
        return _this;
    }
    ToolTip.prototype.componentWillMount = function () {
    };
    ToolTip.prototype.componentDidMount = function () {
    };
    ToolTip.prototype.componentWillReceiveProps = function (nextProps) {
    };
    ToolTip.prototype.componentWillUpdate = function (nextProps, nextState) {
    };
    ToolTip.prototype.componentDidUpdate = function (prevProps, prevState) {
    };
    ToolTip.prototype.componentWillUnmount = function () {
        this._destroyToolTip();
    };
    ToolTip.prototype.handleSwitchGuideShown = function (status, _a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).immediate, immediate = _b === void 0 ? false : _b;
        if (utils_1._isNull(status)) {
            status = !this.state.shown;
        }
        if (!status) {
            var hideFunc = function () {
                if (!_this.hidingConfirmed) {
                    _this.hidingConfirmed = true;
                    return;
                }
                _this.setState({
                    shown: status,
                });
            };
            immediate ? hideFunc() : setTimeout(hideFunc, this.hidingDelayTime);
        }
        else {
            this.setState({
                shown: status,
            });
        }
    };
    ToolTip.prototype.getValidMethod = function (targetMethod, showOrHide) {
        var self = this;
        var method = this.props.method;
        if (method !== targetMethod)
            return utils_1._noop.bind(this);
        return (function (e) {
            var $dom = e.target;
            if (!self.triggerTarget)
                self.triggerTarget = $dom;
            return self.handleSwitchGuideShown(showOrHide);
        }).bind(this);
    };
    ToolTip.prototype._generateToolTip = function (props) {
        var self = this;
        if (this.guideID)
            this._destroyToolTip();
        var $div = document.createElement('div');
        var randomID = "tool-tip-" + Math.random();
        $div.id = randomID;
        $div.className = 'global-tooltip';
        document.body.appendChild($div);
        ReactDOM.render(React.createElement(ToolTipGuide, __assign({}, props)), document.getElementById(randomID), function () { self._calcToolTipPosition(); });
        this.guideID = randomID;
        // bind events
        this._bindEvent();
    };
    ToolTip.prototype._bindEvent = function () {
        var self = this;
        var guideID = self.guideID;
        // not adding a re-calcPosition event when resizing the window, temporarily.
        if (!guideID)
            return;
        var guideDom = document.getElementById(guideID);
        if (!guideDom)
            return;
        var $guideDom = $(guideDom);
        var eventNameSpace = '.l.tooltip';
        var mouseenterEvent = "mouseenter" + eventNameSpace;
        var mouseleaveEvent = "mouseleave" + eventNameSpace;
        var mouseoverEvent = "mouseover" + eventNameSpace;
        $guideDom.off([mouseleaveEvent, mouseenterEvent].join(' '))
            .on(mouseenterEvent, function () {
            self.hidingConfirmed = false;
        }).on(mouseleaveEvent, function (e) {
            self.handleSwitchGuideShown(false, { immediate: true });
        });
    };
    ToolTip.prototype._calcToolTipPosition = function (target, guideDom) {
        if (!target)
            target = this.triggerTarget;
        if (!target)
            return;
        if (!guideDom)
            guideDom = document.getElementById(this.guideID);
        if (!guideDom)
            return;
        var $target = $(target);
        var $guideDom = $(guideDom);
        var targetHeight = $target.outerHeight();
        var targetWidth = $target.outerWidth();
        var targetTop = $target.offset().top;
        var targetLeft = $target.offset().left;
        var guideHeight = $guideDom.outerHeight();
        var guideWidth = $guideDom.outerWidth();
        var guideLeft = targetLeft - guideWidth / 2 + targetWidth / 2;
        // minus a number to guarantee the $guideDom upon the $target.
        // In fact, 10 is tooltip bottom triangle's height.
        var guideTop = targetTop - guideHeight - 10;
        // judge whether too high to not showing all.
        if (guideTop < 0) {
            var $guideDomBody = $guideDom.find('.tooltip-body');
            var guideDomBodyMaxHeight = $guideDomBody.outerHeight() + guideTop;
            if (guideDomBodyMaxHeight < this.tipBodyMinHeight) {
                guideDomBodyMaxHeight = 'none'; // unset maxHeight
            }
            // let guide body overflow and scrollable.
            // It's why use `hidingDelayTime` and `hidingConfirmed`.
            $guideDomBody.css({
                maxHeight: guideDomBodyMaxHeight,
                overflow: 'auto',
            });
            guideTop = 0;
        }
        $guideDom.css({
            left: guideLeft + "px",
            top: guideTop + "px",
        });
    };
    ToolTip.prototype._destroyToolTip = function () {
        if (!this.guideID)
            return;
        var guideDom = document.getElementById(this.guideID);
        if (!guideDom)
            return;
        ReactDOM.render(null, guideDom);
        // document.body.removeChild($div);
        // For best efficiency. Use JQuery to avoid memory leak. (DOM contain events)
        $(guideDom).remove();
        this.guideID = '';
    };
    // Adapt to new feature. Can return Array.
    ToolTip.prototype.render = function () {
        var _a = this.props, children = _a.children, appendIcon = _a.appendIcon, iconClass = _a.iconClass, props = __rest(_a, ["children", "appendIcon", "iconClass"]);
        if (!children && !appendIcon)
            return null;
        var shown = this.state.shown;
        var clickEvent = this.getValidMethod(ToolTipMethods.click);
        var mouseEnterEvent = this.getValidMethod(ToolTipMethods.hover, true);
        var mouseLeaveEvent = this.getValidMethod(ToolTipMethods.hover, false);
        shown ? this._generateToolTip(props) : this._destroyToolTip();
        var $appendedIcon = appendIcon
            ? React.createElement("i", { className: iconClass })
            : null;
        if (children) {
            // @ts-ignore
            var childrenLength = children.length >> 0;
            /**
             * if many children, like:
             *
             * <Tooltip>
             *   <div>1</div>
             *   <div>2</div>
             * </ToolTip>
             *
             * These children all can trigger tooltip event.
             * But, here will record the first DOM who triggered tooltip event, and next time, trigger target will always be it.
             *
             * And if the children had "dangerouslySetInnerHTML", cannot give it a inner children icon, then append it a icon.
             */
            // @ts-ignore
            if (childrenLength > 1 || children.props.dangerouslySetInnerHTML) {
                return [
                    cloneChildrenElement(children, {
                        onClick: clickEvent,
                        onMouseEnter: mouseEnterEvent,
                        onMouseLeave: mouseLeaveEvent,
                        style: { position: 'relative', cursor: 'pointer' },
                    }),
                    $appendedIcon,
                ];
            }
            // if only one children
            return cloneChildrenElement(children, {
                onClick: clickEvent,
                onMouseEnter: mouseEnterEvent,
                onMouseLeave: mouseLeaveEvent,
                style: { position: 'relative', cursor: 'pointer' },
            }, [children.props.children, $appendedIcon]);
        }
        else {
            // If code goes here, property named "appendIcon" must be true.
            // And children is nonexistent, like: <Tooltip title="yes" description="Ooops" />
            // So here will only be one icon, and only this icon could show tooltip. So operated it.
            return cloneChildrenElement($appendedIcon, {
                onClick: clickEvent,
                onMouseEnter: mouseEnterEvent,
                onMouseLeave: mouseLeaveEvent,
                style: { position: 'relative', cursor: 'pointer' },
            });
        }
    };
    ToolTip.defaultProps = {
        title: '',
        description: '',
        method: ToolTipMethods.hover,
        shown: false,
        appendIcon: false,
        iconClass: 'icon-lenovo-drivers-info-icon',
    };
    return ToolTip;
}(React.PureComponent));
exports.default = ToolTip;
